import { render } from "./QuoteSection.vue?vue&type=template&id=4c1e9a21&scoped=true"
import script from "./QuoteSection.vue?vue&type=script&lang=js"
export * from "./QuoteSection.vue?vue&type=script&lang=js"

import "./QuoteSection.vue?vue&type=style&index=0&id=4c1e9a21&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c1e9a21"]])

export default __exports__